import React from 'react';
import Button from '@/components/Button';
import warningIcon from '@/assets/warning_black.svg';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  description, 
  cancelText, 
  confirmText,
  icon
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[311px] bg-white rounded-xl flex flex-col justify-start items-center overflow-hidden">
        <div className="self-stretch px-6 pt-8 pb-6 flex flex-col justify-start items-center gap-2">
          <div className="w-12 h-12 relative overflow-hidden">
            <img src={icon || warningIcon} alt="Dialog Icon" className="w-full h-full" />
          </div>
          <div className="self-stretch text-center text-[#111111] text-lg font-bold leading-[27px]">
            {title}
          </div>
          <div className="self-stretch text-center text-[#666666] text-sm font-normal leading-[21px]">
            {description}
          </div>
        </div>
        <div className="self-stretch px-6 pb-6 bg-white flex flex-col justify-center items-center">
          <div className="self-stretch flex justify-between items-center gap-3">
            {cancelText && (
              <Button 
                variant="default" 
                className="flex-1 min-w-0 !px-3"
                onClick={onClose}
              >
                {cancelText}
              </Button>
            )}
            <Button 
              variant="primary" 
              className="flex-1"
              onClick={onConfirm}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog; 